import axios from 'axios'
import { ClearTokens, GetAccessToken, GetRefreshToken, SetTokens } from "./sessions"
import "./loading.css";

export const API_URL = {
    Loader: window.config.API_TEXTLOADER,
    Authen: window.config.API_AUTHEN,
    Lobby: window.config.API_LOBBY,
    Query: window.config.API_QUERY
};

///////////// Authentication and Authorization /////////////////////////
// add Authorization as default header
axios.interceptors.request.use(async (config) => {
    // document.body.classList.add('loading-indicator');
    //console.log(config.data);
    if (!config.cancelToken) {
        if (config.data?.MODE !== "Refresh") {
            document.body.classList.add('loading-indicator');
        }
    }
    const jwt = GetAccessToken();
    if (jwt != null) {
        config.headers.Authorization = `Bearer ${jwt}`;
    }
    return config;
});

let isRefreshingToken = false;
let isRedirectingToLogin = false;

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function redirectToLogin() {
    if (!isRedirectingToLogin) {
        isRedirectingToLogin = true;
        let urlSaml = `${API_URL.Authen}/auth/Login?returnUrl=/`;
        window.location.replace(urlSaml);
    }
}

axios.interceptors.response.use((response) => {
    // console.log(response.config.data);
     //
    if(response.config.data !== undefined && typeof response.config.data === "string"){
        let res = JSON.parse(response.config.data);
        //console.log(res);
        if(res?.MODE !== "Refresh"){
            document.body.classList.remove('loading-indicator');
        }
    }else{
        document.body.classList.remove('loading-indicator');
    }
    
    //console.log(response);
    
    return response;
}, async error => {
    // console.log(error);
    document.body.classList.remove('loading-indicator');
    if (error.response && error.response.status) {
        if (error.response.status === 401) {
            const originalRequest = error.config
            const refreshToken = GetRefreshToken();
            if (refreshToken && error.config && !error.config.__isRetryRequest) {
                if (isRefreshingToken) {
                    let sleepCount = 50;
                    while (isRefreshingToken && sleepCount > 0) {
                        await sleep(200);
                        sleepCount--;
                    }
                    if (isRefreshingToken) {
                        redirectToLogin();
                    }
                    else {
                        originalRequest._retry = true;
                        document.body.classList.remove('loading-indicator');
                        return new Promise((resolve) => {
                            resolve(axios(originalRequest));
                        });
                    }
                } else {
                    isRefreshingToken = true;
                    return new Promise((resolve) => {
                        originalRequest._retry = true;
                        let url = `${API_URL.Authen}/auth/jwtrefresh`;
                        const response = fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                RefreshToken: refreshToken,
                            }),
                        })
                            .then((res) => res.json())
                            .then((data) => {
                                SetTokens(data.UserId, data.AccessToken, data.RefreshToken);
                                isRefreshingToken = false;
                                return axios(originalRequest);
                            })
                            .catch((err) => {
                                ClearTokens();
                                redirectToLogin();
                            })
                            .finally(() => {
                                isRefreshingToken = false;
                                document.body.classList.remove('loading-indicator');
                            });
                        resolve(response);
                    });
                }
            } else {
                redirectToLogin();
            }
        } else if (error.response.status === 403) {
            // unauthorized (user ไม่มีสิทธิ์)
            // InformationOKDialog("PermissionDenied")
        }
        else if (error.response.status === 400) {
            return { data: { Incorrect: true } }
        }
    }
    // console.log(error);
    if (axios.isCancel(error)) {
        console.log(error);
    }
    else {
        return Promise.reject(error)
    }
    //return Promise.reject(error) 
});